export default __webpack_public_path__ + "static/media/maintenance_img.6f831fe5.png";